export default {
  label: {
    duplicateCardLabel: 'Duplicar',
    filterCardLabel: 'Filtrar',
    resizeCardLabel: 'Redimensionar',
    deleteCardLabel: 'Eliminar',
    expandCardLabel: 'Expandir',
  },
};
